
import Vue from 'vue';
import { api, AutoTagRule } from '@/services/api';
import FileInput from '@/components/FileInput.vue';
import { exportFile, readFile } from '@/services/fileHelper';
import AutoTagRuleEditor from './AutoTagRuleEditor.vue';
import { formatAutoTagRule } from '@/services/autoTagRuleText';

export default Vue.extend({
    components: {
        FileInput,
        AutoTagRuleEditor
    },
    data() {
        return {
            autoTagRules: [] as AutoTagRule[],
            editingAutoTagRule: null as null | AutoTagRule,
            filter: ""
        }
    },
    async mounted() {
        await this.refreshAutoTagRules();
    },
    methods: {
        async refreshAutoTagRules() {
            this.autoTagRules = await api.getAutoTagRules();
        },
        async loadAutoTagRulesFile(file: File) {
            const data = await readFile(file);
            this.autoTagRules = JSON.parse(data) as AutoTagRule[];
        },
        async exportAutoTagRules() {
            await exportFile(JSON.stringify(this.autoTagRules, null, 2), "autoTagRules.json");
        },
        addAutoTag() {
            const rule: AutoTagRule = {
                description: "",
                matchers: [],
                tag: ""
            };
            this.autoTagRules.push(rule);
            this.editingAutoTagRule = rule;
        },
        editAutoTag(autoTagRule: AutoTagRule) {
            this.editingAutoTagRule = autoTagRule;
        },
        deleteAutoTag(autoTagRule: AutoTagRule) {
            const index = this.autoTagRules.indexOf(autoTagRule);
            if (index >= 0) {
                this.autoTagRules.splice(index, 1);
            }
        },
        async saveAutoTagRules() {
            await api.setAutoTagRules(this.autoTagRules);
        },
        ruleText(rule: AutoTagRule): string {
            return formatAutoTagRule(rule).split(/\r?\n/).slice(1).join("\n");
        },
        ruleKey(rule: AutoTagRule, index: number): string {
            return `${index}:${rule.tag}:${rule.description}`;
        }
    },
    computed: {
        filteredAutoTagRules(): AutoTagRule[] {
            const filter = this.filter.trim().toLowerCase();
            if (filter.length === 0) {
                return this.autoTagRules;
            }
            return this.autoTagRules.filter(rule => {
                const haystack = [
                    rule.tag,
                    rule.description,
                    this.ruleText(rule)
                ].join(" ").toLowerCase();
                return haystack.includes(filter);
            });
        }
    }
})
